import { useAppSelector } from "@/lib/redux/hooks"
import { useMemo } from "react"
import { useTour } from "./useTour"

export const useIsMaxPeople = () => {
  const { tour: { data: tour } } = useTour()
  const inputAdt = useAppSelector(state => state.tour.inputTour.inputAdt)
  const inputChd1 = useAppSelector(state => state.tour.inputTour.inputChd1)
  const inputChd2 = useAppSelector(state => state.tour.inputTour.inputChd2)
  const inputInf = useAppSelector(state => state.tour.inputTour.inputInf)

  const selectedDepartureSchedule = useAppSelector(state => state.tour.inputTour.selectedDepartureSchedule)

  const remainingSlots = useMemo(() => {
    if (!selectedDepartureSchedule) {
      return 0
    }
    const departureSchedule = tour?.departureSchedule?.find(d => d.id === selectedDepartureSchedule)
    return departureSchedule?.remainingSlots || 0
  }, [selectedDepartureSchedule, tour?.departureSchedule])

  return (remainingSlots - (inputAdt + inputChd1 + inputChd2 + inputInf)) <= 0
}